import script from "./AdminDashBoard.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminDashBoard.vue?vue&type=script&setup=true&lang=ts"

import "./AdminDashBoard.vue?vue&type=style&index=0&id=1e3779ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e3779ea"]])

export default __exports__